var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTransfer = function SvgTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.095 7.94h5.791l-1.44-1.437.571-.567 2.406 2.406-2.406 2.405-.57-.57 1.44-1.435H6.093v-.803z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.466 1.705H2.534A1.664 1.664 0 0 0 .875 3.364v9.954a1.664 1.664 0 0 0 1.66 1.66H8.34v1.658H6.68v1.66h6.637v-1.66H11.66v-1.659h5.807a1.664 1.664 0 0 0 1.659-1.659V3.364a1.664 1.664 0 0 0-1.66-1.66zm0 11.613H2.534V3.364h14.932v9.954z",
    fill: "currentColor"
  })));
};
export default SvgTransfer;